import React, { useState, useEffect } from 'react';
import { Modal, Col, Button, Tooltip } from 'antd';
import { listApplyWhite } from '../apis.js';
import ComponentLog from '@/components/component-log';
import { formateTimeStamp } from '@/common/utils';
import Time from '@/components/SpacialListConfig/image/time.svg';
import CoreEmpty from '@/components/core-empty';

export default function SelectWhiteModal(props: any) {
  const { selectWhiteModalVisible, setSelectWhiteModalVisible, businessId, businessType } = props;
  const [loading, setLoading] = useState(false);

  const [whiteType, setWhiteType] = useState<
    {
      whiteType: number;
      whiteName: string;
      id: number;
      applyContent: string;
      organization: string;
      applyBeginTime: number;
      applyEndTime: number;
      organizationName: string;
      createErp: string;
    }[]
  >([]);

  const extraInfo = (item: any) => {
    const _extraInfo = [
      {
        key: '创建人',
        value: item?.createErp,
      },
      {
        key: '申请时间',
        value: `${formateTimeStamp(item?.applyBeginTime, true)} -
            ${formateTimeStamp(item?.applyEndTime, true)}`,
      },
      {
        key: '所属部门',
        value: item?.organizationName,
      },
    ];
    return _extraInfo;
  };

  useEffect(() => {
    if (!selectWhiteModalVisible) {
      return;
    }
    setLoading(true);
    // 获取白名单类型
    listApplyWhite({ businessType, businessId })
      .then(({ ret, msg, data }) => {
        if (ret === '0' && data) {
          setWhiteType(data?.list);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [selectWhiteModalVisible, businessType]);

  const isInTimeRange = (currentTime: any, startTime: any, endTime: any) => {
    return currentTime >= startTime && currentTime <= endTime;
  };

  function openWhiteApplyConfig(item: any) {
    (window.ACORE as any).openWhiteListDrawer.showApply({
      businessType: businessType,
      businessId: businessId,
      title: item.whiteName,
      descriptionList: extraInfo(item),
      whiteTypeId: item.id,
    });
  }

  return (
    <Modal
      visible={selectWhiteModalVisible}
      width={916}
      title="选择白名单"
      onCancel={() => setSelectWhiteModalVisible(false)}
      footer={null}
    >
      {whiteType?.length ? (
        <div
          style={{
            display: 'flex',
            flexDirection: whiteType.length === 1 ? 'column' : 'row',
            flexWrap: 'wrap',
            justifyContent: whiteType.length === 1 ? 'center' : 'flex-start',
            alignItems: 'center',
            textAlign: 'left',
          }}
        >
          {whiteType?.map((ele: any) => (
            <Col
              key={ele.id}
              style={{
                width: whiteType.length === 1 ? '100%' : 'calc(50% - 20px)',
                margin: whiteType.length === 1 ? '0 10px' : '10px',
                border: '1px solid #f7f7f7',
                padding: '10px',
                borderRadius: '5px',
              }}
            >
              <Tooltip title={ele.whiteName} placement="topLeft">
                <h3
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: 'block',
                  }}
                >
                  {ele.whiteName}
                </h3>
              </Tooltip>
              <div style={{ fontSize: '12px', color: '#00000073' }}>创建人：{ele.createErp}</div>
              <Tooltip title={ele.organizationName}>
                <span
                  style={{
                    fontSize: '12px',
                    color: '#00000073',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: 'block',
                  }}
                >
                  部门：{ele.organizationName}
                </span>
              </Tooltip>
              <div style={{ width: '380px', height: '1px', background: '#f7f7f7', margin: '5px 0' }}></div>
              <div>
                <img src={Time} />
                <span style={{ marginLeft: '5px', fontSize: '12px' }}>
                  申请时间：
                  {formateTimeStamp(ele?.applyBeginTime, true)} - {formateTimeStamp(ele.applyEndTime, true)}
                </span>
              </div>
              <ComponentLog clstag="yx_whiteapply_page_1706591686206|14">
                <Button
                  type="primary"
                  style={{ marginTop: '5px' }}
                  ghost
                  disabled={!isInTimeRange(Date.now(), ele?.applyBeginTime, ele.applyEndTime)}
                  onClick={() => {
                    openWhiteApplyConfig(ele);
                  }}
                >
                  去申请
                </Button>
              </ComponentLog>
            </Col>
          ))}
        </div>
      ) : (
        <CoreEmpty description="暂无可申请的白名单" />
      )}
    </Modal>
  );
}
